module.exports = __webpack_public_path__ + "img/web_asset.b3195ee8.svg";